export default "__VITE_ASSET__DQ$4rhUc__"